import React, { useMemo, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Unstable_Grid2';
import FormHelperText from '@mui/material/FormHelperText';
import { fieldSizing } from '../../utils/utilities';
import FieldInfo from '../FieldInfo/FieldInfo';


const RadioButton = ({
  label,
  name,
  options,
  required,
  value,
  setValue,
  size,
  withInfo = false,
  description,
  error,
  errorMsg = "This is a required field",
  disabled
}) => {
  const [tempVal , setTempVal] = useState(value)

  const handleChange = (ev) => {
    if (setValue){
      setValue(ev.target.value)
      setTempVal(ev.target.value)
    }
  }

  const fieldSize = useMemo(() =>
    fieldSizing(size)
    , [size])

  return (
    <Grid xs={fieldSize.xs} sm={fieldSize.sm} md={fieldSize.md} lg={fieldSize.lg} >
      <FormControl error={error}>

        <FormLabel >
          {withInfo ?
            <FieldInfo content={description} label={required ? label + " *" : label} /> 
            :
            `${label}`
          }
        </FormLabel>

        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={tempVal ? tempVal  : ""}
          onChange={handleChange}
        >
          {options && options.map((val) => (
            <FormControlLabel
              value={val}
              control={<Radio />}
              label={val}
              key={val}
              disabled={disabled}
            />
          )
          )}
        </RadioGroup>
      </FormControl>
      <FormHelperText error> {error ? errorMsg : ""} </FormHelperText>

    </Grid>

  );
}

export default RadioButton;